import { axisClasses, barLabelClasses } from '@mui/x-charts';
import { axisColorMap, darkGray, lightGray } from '../../../theme';

type SeriesId = string;

type ChartStylesOptions = {
  seriesStyling?: Record<
    SeriesId,
    { dottedLine: boolean; stroke: string | undefined }
  >;
};

export const chartStyles = (options?: ChartStylesOptions) => ({
  [`.${axisClasses.root}`]: {
    [`.${axisClasses.tick}, .${axisClasses.line}`]: {
      stroke: lightGray,
      strokeWidth: 1,
    },
  },
  [`.${axisClasses.directionY}`]: {
    [`.${axisClasses.tickLabel}`]: {
      fill: axisColorMap['left'],
    },
  },
  [`.${axisClasses.directionY}.${axisClasses.right}`]: {
    [`.${axisClasses.tickLabel}`]: {
      fill: axisColorMap['right'],
    },
  },
  [`.${axisClasses.directionX}`]: {
    [`.${axisClasses.tickLabel}`]: {
      fill: darkGray,
    },
  },
  [`.${barLabelClasses.root}`]: {
    fill: 'rgb(0,0,0)',
  },
  ...Object.entries(options?.seriesStyling ?? {}).reduce(
    (acc, [seriesId, config]) => {
      return {
        ...acc,
        [`.MuiLineElement-series-${seriesId}`]: {
          stroke: config.stroke,
          strokeDasharray: config.dottedLine ? '4' : 'none',
        },
      };
    },
    {}
  ),
});
